import React, { useEffect, useState } from 'react';
import Adjudication from '../SubmitInvoice/InvoiceAdjudication';
import { historyPush } from '../../components/Global/helpers.jsx';

let rfsData = null;

export const SubmitInvoice = (props) => {
    const [state, setState] = useState({
        eventId: props?.invoiceRecords?.eventId,
        clientId: props?.invoiceRecords?.clientId,
        eventNumber: props?.invoiceRecords?.eventNumber,
        modelNumber: props?.invoiceRecords?.modelNumber,
        serialNumber: props?.invoiceRecords?.serialNumber,
        brandName: props?.invoiceRecords?.brandName,
        servicerPhone: props?.invoiceRecords?.servicerPhone,
        preauthorizedAmount: props?.invoiceRecords?.preauthorizedAmount,
        currentClaimOverviewId: 0,
        isRequestedFromOtherSite: false,
        isLoaded: false,
        rfsData: props?.invoiceRecords?.rfsData !== undefined ? props?.invoiceRecords?.rfsData : {}
    });

    useEffect(() => {
        historyPush(props?.invoiceRecords, 'requestforservice', null, state?.clientId, callGetRFSData, false);
        callGetRFSData();
    }, []);

    const GetRFSFormData = async (urlParams) => {
        fetch(`claim/GetRFSSummaryByEventId/${state?.clientId}?${urlParams?.toString()}`)
            .then((res) => res.json())
            .then((data) => {
                rfsData = data;
                setState({
                    isLoaded: true,
                    eventNumber: rfsData.eventNumber,
                    modelNumber: rfsData.modelNumber,
                    serialNumber: rfsData.serialNumber,
                    brandName: rfsData.brand,
                    rfsData
                });
            });
    };

    const callGetRFSData = (urlParams) => {
        setState({ urlParams });

        if (state?.isRequestedFromOtherSite) GetRFSFormData(urlParams);
        else setState({ isLoaded: true });
    };

    return (
        <Adjudication
            eventNumber={state?.eventNumber}
            eventId={state?.eventId}
            claimId={state?.currentClaimOverviewId}
            clientId={state?.clientId}
            modelNumber={state?.modelNumber}
            serialNumber={state?.serialNumber}
            brandName={state?.brandName}
            preauthorizedAmount={state?.preauthorizedAmount}
            servicerPhone={state?.servicerPhone}
            rfsData={state?.rfsData}
        />
    );
};
